module.exports = __webpack_public_path__ + "img/CNG.608ad20b.svg";